document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.sevenvn-ingredient-breakdown');

  if (!sections.length) return;

  const revealItems = (section) => {
    section.querySelectorAll('[data-ingredient-reveal]').forEach((item) => {
      item.classList.add('is-visible');
    });
  };

  if (!('IntersectionObserver' in window)) {
    sections.forEach(revealItems);
    return;
  }

  const observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      instance.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -8% 0px',
  });

  sections.forEach((section) => {
    if (section.classList.contains('sevenvn-ingredient-breakdown--no-reveal')) {
      revealItems(section);
      return;
    }

    section.querySelectorAll('[data-ingredient-reveal]').forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index * 55, 330)}ms`;
      observer.observe(item);
    });
  });
});
